import { create } from "zustand";
import { Modal } from "bootstrap";
const closeModal = () => {
    const modalElement = document.getElementById("quoteModal");
    if (!modalElement)
        return;
    const bootstrapModel = Modal.getInstance(modalElement) || new Modal(modalElement);
    bootstrapModel.hide();
};
const useStore = create((set) => ({
    isOpen: false,
    setOpen: () => set({ isOpen: true }),
    setClose: () => {
        closeModal();
        set({ isOpen: false });
    },
}));
export default useStore;
